export default {
  computed: {
    buttonText () {
      if (this.isVariationGroupMaster && this.isListing) {
        return this.t('product_status.select.variation')
      }

      if (!this.available && !this.cartLimitReached) {
        return this.t('product_status.unavailable.coming_soon')
      }

      if (!this.available && this.hasAttributes && !this.selectedAttributeId) {
        return this.t('product_status.unavailable.choose_attr')
      }

      if (this.cartLimitReached || this.isProductInAvailabilityDate) {
        return this.t('product_status.unavailable.text')
      }

      if (this.progress) {
        return `${this.t('product_status.progress')}...`
      }

      if (!this.onlineStatus) {
        return `<i class="icon-energy icons"></i>${this.t('online_status.offline')}`
      }

      return this.t('add_to_cart')
    },
    disabled () {
      return this.quantity < 1 || !this.onlineStatus || !this.available || this.progress || this.cartLimitReached || this.isProductInAvailabilityDate
    },
    available () {
      return this.stock > 0 && !this.unavailable
    },
    isProductInAvailabilityDate () {
      const { availableFrom, availableUntil } = this.productData
      if (availableFrom || availableUntil) {
        const currentDate = Date.now()
        return (
          (availableFrom != null && currentDate < new Date(availableFrom).getTime()) ||
          (availableUntil != null && currentDate > new Date(availableUntil).getTime())
        )
      }
      return false
    }
  }
}
